module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "custom-class": "dialog-wrapper",
      "title": _vm.dialogTitle,
      "close-on-click-modal": false,
      "modal-append-to-body": false
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "flex-row-center"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.dialogVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.clickEditDone
          }
        }, [_vm._v("确定")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, _vm._l((_vm.configList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "margin-bottom-10"
    }, [_c('el-form-item', {
      attrs: {
        "label": "手机型号"
      }
    }, [_c('el-input', {
      model: {
        value: (_vm.configList[index].type),
        callback: function($$v) {
          _vm.$set(_vm.configList[index], "type", $$v)
        },
        expression: "configList[index].type"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "版本号"
      }
    }, [_c('el-input', {
      model: {
        value: (_vm.configList[index].version),
        callback: function($$v) {
          _vm.$set(_vm.configList[index], "version", $$v)
        },
        expression: "configList[index].version"
      }
    })], 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.clickAddConfig
      }
    }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), (index != 0) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          return _vm.clickDeleteConfig(index)
        }
      }
    }) : _vm._e()], 1)
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-205f729b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/SystemConfig/SystemConfig/Components/PhoneCodeShield.vue
// module id = 965
// module chunks = 0